{
 "_meta": {
  "locale": "uk",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "Зараз",
  "people": "Люди",
  "cases": "Справи",
  "agenda": "Щоденник",
  "reviews": "Огляди",
  "prospects": "Залучення",
  "insights": "Аналітика",
  "data": "Дані та безпека",
  "settings": "Налаштування",
  "lens": "Лупа"
 },
 "common": {
  "save": "Зберегти",
  "cancel": "Скасувати",
  "close": "Закрити",
  "search": "Пошук",
  "today": "Сьогодні",
  "tomorrow": "Завтра",
  "new": "Новий",
  "edit": "Редагувати",
  "delete": "Видалити"
 },
 "settings": {
  "title": "Налаштування",
  "language": "Мова",
  "region": "Ринок / регіон",
  "theme": "Вигляд"
 },
 "people": {
  "title": "Люди",
  "new": "Нова людина"
 },
 "today": {
  "agenda_title": "Сьогодні"
 },
 "lens": {
  "placeholder": "Пошук людей, потенційних клієнтів, справ — або введіть команду"
 }
}